import React, { FC, PropsWithChildren } from 'react';

import styles from './footer.module.scss';

export const Footer: FC<PropsWithChildren> = ({ ...rest }) => (
  <footer className={styles.footer} {...rest} />
);
